import { memo } from 'react';
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Table.module.scss';

interface TableRowProps {
    children?: ReactNode;
    errorRow?: boolean;
    highlightSuccess?: boolean;
    highlightError?: boolean;
    fadeOutRow?: boolean;
    onClick?: () => void;
    disableRelativeTrFix?: boolean;
}

const TableRow = ({
    children,
    onClick,
    errorRow = false,
    highlightError = false,
    highlightSuccess = false,
    fadeOutRow = false,
    //  @TODO check all places where relativeFix is indeed.
    disableRelativeTrFix = false,
    ...ariaOrDataProps
}: TableRowProps) => {
    return (
        <tr
            className={clsx(styles.tableRow, {
                [styles.clickableRow]: !!onClick,
                [styles.successRow]: highlightSuccess,
                [styles.errorRow]: highlightError,
                [styles.errorBorder]: errorRow,
                [styles.fadeOutRow]: fadeOutRow,
                [styles.relativeTrFix]: !disableRelativeTrFix,
            })}
            {...ariaOrDataProps}
            onClick={onClick}
        >
            {children}
        </tr>
    );
};

export const TableSpacer = memo(() => (
    <tr>
        <td colSpan={100} className={styles.tableSpacer} />
    </tr>
));

export const TableDivider = memo(() => (
    <tr>
        <td colSpan={100} className={styles.tableDivider} />
    </tr>
));

/**
 * @deprecated
 * Please use `TableRow` from `@library`
 */
export default memo(TableRow);
